<template>
  <div class="info-region-container">
    <div class="all-content-container" style="margin: 0 auto; width: 100%">
      <div class="container1">
        <div class="titlemaun" style="">
          <h4>实时告警数据</h4>
        </div>
        <div class="gjform">
          <el-form :inline="true" :model="searchForm" class="demo-form-inline">
            <el-form-item label="设备类型：" prop="type">
              <el-select v-model="searchForm.type" placeholder="请选择设备类型" clearable @change="typeChange">
                <el-option label="数值" value="0"></el-option>
                <el-option label="视频" value="1"></el-option>
                <el-option label="开关" value="3"></el-option>
                <el-option label="网关" value="4"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设备名称：" prop="eid">
              <el-select v-model="searchForm.eid" placeholder="请选择设备名称" clearable @change="deviceChange">
                <el-option v-for="(item, index) in deviceArray" :label="item.name" :value="item.id" :key="index"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="属性名称：" prop="attributeId">
              <el-select v-model="searchForm.attributeId" placeholder="请选择属性名称" clearable @change="searchKey">
                <el-option v-for="(item, index) in attributeArray" :label="item.name" :value="item.id" :key="index"> </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="时间：" prop="time">
              <el-date-picker v-model="searchForm.time" :picker-options="pickerOptions" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right"> </el-date-picker>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" class="button" @click="searchKey()">查询</el-button>
              <el-button type="button" ass="button" @click="reset()">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="info-content-container" style="margin-top: 10px">
        <div class="table_count1" style="margin-top: 10px">
          <el-table :data="tableData" align="center" boder class="data-table" style="width: 100%" v-loading="loading" :header-cell-style="{ background: '#F4F5F7' }">
            <el-table-column align="center" label="序号" width="95">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="deviceName" align="center" label="设备名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="attributeName" align="center" show-overflow-tooltip label="属性名称"></el-table-column>
            <el-table-column prop="alarmType" align="center" show-overflow-tooltip label="告警内容"></el-table-column>
            <el-table-column prop="value" align="center" show-overflow-tooltip label="环境数值"></el-table-column>
            <el-table-column prop="symbol" align="center" show-overflow-tooltip label="单位"></el-table-column>
            <el-table-column prop="startTime" align="center" show-overflow-tooltip label="告警开始时间"></el-table-column>
            <el-table-column prop="endTime" align="center" show-overflow-tooltip label="告警结束时间"></el-table-column>
            <!-- <el-table-column align="center" label="操作">
              <template slot-scope="scope" v-allow="'060502'">
                <el-button @click="alarmStatisticsEcahrts(scope.row.groupId)" type="text" size="small">告警统计</el-button>
              </template>
            </el-table-column> -->
          </el-table>
        </div>
        <div class="pagination-container">
          <div class="page"></div>
          <div class="pagination-content-container">
            <el-pagination background layout="prev, pager, next,jumper" class="pageTap" @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pagesize" :total="total"></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'alarmLog',
  data() {
    return {
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        type: '',
        eid: '',
        attributeId: '',
        modelOfflineSettingsId: '',
        time: []
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 3)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近五天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 5)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }
          // {
          //   text: '最近三个月',
          //   onClick(picker) {
          //     const end = new Date()
          //     const start = new Date()
          //     start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
          //     picker.$emit('pick', [start, end])
          //   }
          // }
        ]
      },
      deviceArray: [], // 设备数组
      attributeArray: [], // 属性数组
      optionProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        checkStrictly: true
      },
      currentPage: 1,
      total: 0,
      groupId: 1,
      groupId2: '',
      pagesize: 10,
      loading: false, //加载
      formInline: {
        //查询条件（参数）（0，1）
        scene: '',
        template: '',
        user: '',
        stasticTime: ''
      },
      dialogformInline: {
        name: ''
      },
      sceneListData: [],
      templateList: [],
      tableData: [],
      noneList: [{}],
      approveResult: ''
    }
  },

  computed: {},
  created() {
    var that = this

    that.init()
  },
  mounted() {},
  methods: {
    // 类型下拉切换
    typeChange() {
      // 清空
      this.searchForm.eid = ''
      this.searchForm.attributeId = ''
      this.deviceArray = []
      this.attributeArray = []

      // 获取设备列表
      this.getDeviceList()

      // 查询
      this.searchKey()
    },
    searchKey() {
      this.getModelAttributeHisList()
    },
    reset() {
      this.searchForm = {
        pageNum: 1,
        pageSize: 10,
        type: '',
        eid: '',
        attributeId: '',
        modelOfflineSettingsId: '',
        time: []
      }
      this.currentPage = 1
      this.searchKey()
    },
    // 设备下拉切换
    deviceChange() {
      // 清空
      this.searchForm.attributeId = ''
      this.attributeArray = []

      // 获取属性列表
      this.getAttributeList()

      // 查询
      this.searchKey()
    },
    // 获取设备列表
    getDeviceList() {
      if (this.searchForm.type === '') {
        return
      }

      if (this.searchForm.type == 0) {
        // 数值设备
        this.$api.device.getDeviceNumericalAll().then(res => {
          if (res.code == 200) {
            res.data.forEach(val => {
              this.deviceArray.push({
                id: val.id,
                name: val.name
              })
            })
          }
        })
      } else if (this.searchForm.type == 1) {
        // 视频设备
        this.$api.device.getDeviceVideoAll().then(res => {
          if (res.code == 200) {
            res.data.forEach(val => {
              this.deviceArray.push({
                id: val.id,
                name: val.name
              })
            })
          }
        })
      } else if (this.searchForm.type == 2) {
        // 图片设备
        this.$api.device.getDevicePicAll().then(res => {
          if (res.code == 200) {
            res.data.forEach(val => {
              this.deviceArray.push({
                id: val.id,
                name: val.name
              })
            })
          }
        })
      } else if (this.searchForm.type == 3) {
        // 开关设备
        this.$api.device.getDeviceSwitchAll().then(res => {
          if (res.code == 200) {
            res.data.forEach(val => {
              this.deviceArray.push({
                id: val.id,
                name: val.name
              })
            })
          }
        })
      } else if (this.searchForm.type == 4) {
        // 网关设备
        this.$api.device.getDeviceGatewayAll().then(res => {
          if (res.code == 200) {
            res.data.forEach(val => {
              this.deviceArray.push({
                id: val.id,
                name: val.gatewayName
              })
            })
          }
        })
      }
    },
    // 获取属性列表
    getAttributeList() {
      if (this.searchForm.type === '' || this.searchForm.type === '4' || this.searchForm.eid === '') {
        return
      }

      this.$api.device
        .getDeviceAttributes({
          type: this.searchForm.type,
          eid: this.searchForm.eid
        })
        .then(res => {
          if (res.code == 200) {
            res.data.forEach(val => {
              this.attributeArray.push({
                id: val.id,
                name: val.cname
              })
            })
          }
        })
    },
    //id
    change_val(val) {
      this.groupId = val[val.length - 1] || ''
      this.getModelAttributeHisList() //查询列表
    },
    add() {},
    // 重置
    resetonSubmit() {
      this.groupId = this.groupId2
      this.getModelAttributeHisList() //查询列表
    },
    init() {
      this.getAllGrowthCropsList()
      this.getModelAttributeHisList() //列表信息
      //  this.getAllApproveTemplate();
      this.getModelAttributeHisList() //查询告警记录列表
    },
    handleCurrentChange(val) {
      console.log(val)
      //下一页
      this.currentPage = val
      this.getModelAttributeHisList() //查询列表
    },
    // 查询
    onSubmit() {
      this.getModelAttributeHisList() //查询列表
    },
    // 种植大棚
    getAllGrowthCropsList() {
      console.log('断点')
      this.$api.system
        .getGroupList()
        .then(res => {
          if (res.code == 200) {
            console.log('res.data', res.data)
            //this.groupId=res.data[0].id
            this.groupId2 = res.data[0].id
            this.templateList = res.data //  种植大棚
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(err => {
          this.$message.error(err)
        })
    },

    // 查询全部审批模板
    getAllApproveTemplate() {
      this.$api.system.getAllApproveTemplate().then(res => {
        if (res.code == 200) {
          console.log('888888')
          console.log(res)
          this.templateList = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    //告警统计图表
    alarmStatisticsEcahrts(id) {
      console.log('888888')
      this.$router.push({
        name: 'alarmStatistics',
        query: {
          id: id
        }
      })
    },

    // 查询告警记录列表
    getModelAttributeHisList() {
      let a = {
        pageNum: this.currentPage,
        pageSize: this.pagesize,

        deviceId: this.searchForm.deviceId,
        attributeId: this.searchForm.attributeId,
        startTime: this.searchForm.time[0],
        endTime: this.searchForm.time[1]
      }
      this.$api.groupAlarm.getHomeDataRealAlarmList(a).then(res => {
        if (res.code == 200) {
          this.tableData = res.data
          this.total = res.count
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  }
}
</script>
<style scoped>
@import '../../style/approvalTemplate.scss';
</style>
